var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        if (!$event.ctrlKey) { return null; }
        _vm.toggleRemarkable($event)
      }
    }
  }, [_c('Ace', {
    ref: "ace",
    attrs: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onDocumentChanged,
      "slow-change": _vm.saveDocument
    }
  }), _vm._v(" "), _c('MarkdownToHtml', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.remarkableIsVisible),
      expression: "remarkableIsVisible"
    }],
    attrs: {
      "value": _vm.currentValue
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab toggle-remarkable",
    on: {
      "click": _vm.toggleRemarkable
    }
  }, [(_vm.remarkableIsVisible) ? _c('md-icon', [_vm._v("visibility_off")]) : _c('md-icon', [_vm._v("visibility")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f2f2ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = hMxL
// module chunks = 1